import { useModal } from "@/components/essex/ModalContext";
import { Link, useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
  const { openModal } = useModal();
  const location = useLocation();
  const navigate = useNavigate();

  const handleAnchorClick = (e, href) => {
    e.preventDefault();
    if (location.pathname === "/" || location.pathname === "/essex") {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/", { state: { scrollTo: href } });
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#080706] py-20 md:py-28 border-t border-[#2A2826]/30"
      aria-label="Site footer"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="text-center">
          <h2
            data-testid="footer-heading"
            className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tighter font-light text-[#F5F5F0]/25 leading-none select-none"
          >
            Wedding Video Essex
          </h2>

          <p className="mt-8 text-sm text-[#A19D94] font-sans max-w-lg mx-auto leading-relaxed">
            Award winning cinematic wedding photography and videography across Essex, London, Kent, and the South East.
            Trusted by 900+ couples. Let's make yours next.
          </p>

          <button
            onClick={openModal}
            data-testid="footer-secure-date-btn"
            className="mt-6 px-8 py-3 bg-[#C2A878] text-[#0A0908] text-sm font-sans font-medium tracking-wider uppercase hover:bg-[#d4bc92] transition-colors"
          >
            Secure Your Date
          </button>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-6">
            <a
              href="https://weddingvideo.co.uk"
              data-testid="footer-main-site"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              Main Website
            </a>
            <span className="text-[#2A2826]">|</span>
            <a
              href="#films"
              onClick={(e) => handleAnchorClick(e, "#films")}
              data-testid="footer-films-link"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              Our Films
            </a>
            <span className="text-[#2A2826]">|</span>
            <a
              href="#venues"
              onClick={(e) => handleAnchorClick(e, "#venues")}
              data-testid="footer-venues-link"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              Essex Venues
            </a>
            <span className="text-[#2A2826]">|</span>
            <Link
              to="/about"
              data-testid="footer-about-link"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              About Us
            </Link>
            <span className="text-[#2A2826]">|</span>
            <Link
              to="/guide"
              data-testid="footer-guide-link"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              Pricing Guide
            </Link>
            <span className="text-[#2A2826]">|</span>
            <a
              href="#faq"
              onClick={(e) => handleAnchorClick(e, "#faq")}
              data-testid="footer-faq-link"
              className="text-xs tracking-[0.15em] uppercase text-[#A19D94] hover:text-[#C2A878] transition-colors font-sans"
            >
              FAQ
            </a>
          </div>

          <div className="mt-12 pt-8 border-t border-[#2A2826]/20">
            <p className="text-xs text-[#A19D94]/50 font-sans">
              &copy; {new Date().getFullYear()} Wedding Video Essex. All rights reserved.
              Part of <a href="https://weddingvideo.co.uk" className="hover:text-[#C2A878] transition-colors">weddingvideo.co.uk</a>
            </p>
            <p className="mt-3 text-[10px] text-[#A19D94]/30 font-sans leading-relaxed max-w-3xl mx-auto">
              Wedding photographer and videographer covering Essex, London, Kent, and the South East including Chelmsford, Colchester, Brentwood, Southend on Sea, Basildon, Harlow, Epping, Braintree, Maldon, Witham, Billericay, Rochford, Halstead, Ongar, Burnham on Crouch, Great Dunmow, Coggeshall and surrounding areas. Venues we cover include Gaynes Park, Baddow Park, High House, Leez Priory, Gosfield Hall, Braxted Park, Friern Manor, Houchins, Mulberry House, Apton Hall and The Lawn.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
